import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import { DigitalSignageScreenReqModel } from '@modules/digital-signage/model/screens.model.ts';

export interface ScreensParams {
  data?: DigitalSignageScreenReqModel;
  id?: any;
  state?: any;
  handleClose?: () => void;
}
export interface ScreensState extends CallStateMethods {
  callState: CallStateEnum;
  createRow: (params: ScreensParams) => void;
  editRow: (params: ScreensParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose?: () => void;
  }) => void;
}

interface ScreensStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
}

export const SCREENS_INITIAL_STATE: Omit<
  ScreensStateMethods,
  keyof ScreensState
> = {
  callState: CallStateEnum.Init
};
